/*
 * sg-pricing.js
 *
 * Shows the right time segment of server-rendered prices (snippets/sg-pricing-engine.liquid).
 * Elements with data-sg-segments hold [{from, html}, ...] sorted by `from` (epoch seconds).
 * The last segment whose `from` has passed on the visitor's clock is shown.
 * No price math happens here; every segment's HTML was rendered by Liquid, and only
 * for rules this visitor is entitled to.
 *
 * Re-runs at the next boundary, when the tab becomes visible again, and when price HTML is
 * added later (variant switch, quick add, predictive search, recommendations, AJAX collections).
 */
(function () {
  var MAX_DELAY = 86400000; // setTimeout overflows past ~24.8 days; re-check daily instead
  var timer = null;
  var queued = false;

  function nowSeconds() {
    return Math.floor(Date.now() / 1000);
  }

  // Returns the next boundary for this element, or null.
  function apply(el, now) {
    var segments;
    try {
      segments = JSON.parse(el.getAttribute('data-sg-segments'));
    } catch (e) {
      return null;
    }
    if (!segments || !segments.length) return null;

    var index = 0;
    for (var i = 0; i < segments.length; i++) {
      if (segments[i].from <= now) index = i;
    }

    if (el.getAttribute('data-sg-active') !== String(index)) {
      el.innerHTML = segments[index].html;
      el.setAttribute('data-sg-active', String(index));
    }

    return segments[index + 1] ? segments[index + 1].from : null;
  }

  function run() {
    queued = false;
    var now = nowSeconds();
    var next = null;

    document.querySelectorAll('[data-sg-segments]').forEach(function (el) {
      var boundary = apply(el, now);
      if (boundary && (next === null || boundary < next)) next = boundary;
    });

    clearTimeout(timer);
    if (next) {
      timer = setTimeout(run, Math.min((next - now) * 1000 + 500, MAX_DELAY));
    }
  }

  function queueRun() {
    if (queued) return;
    queued = true;
    (window.requestAnimationFrame || setTimeout)(run);
  }

  function hasSegments(node) {
    return node.nodeType === 1 && (node.hasAttribute('data-sg-segments') || node.querySelector('[data-sg-segments]'));
  }

  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (hasSegments(added[j])) return queueRun();
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) run();
  });

  run();

  // Parity mode (Theme settings > Pricing display): report legacy vs metaobject differences.
  var mismatches = document.querySelectorAll('[data-sg-parity="mismatch"]');
  if (mismatches.length) {
    mismatches.forEach(function (el) {
      console.warn('[sg-pricing] parity mismatch', el.getAttribute('data-sg-parity-product'), {
        legacy: el.getAttribute('data-sg-parity-legacy'),
        engine: el.getAttribute('data-sg-parity-engine')
      });
    });
  }
})();
